import { createApi } from "@reduxjs/toolkit/query/react";
import { createBaseQueryWithLogoutGuard } from "../../../common/createBaseQueryWithLogoutGuard";

export const primaryCheckingAccountSlice = createApi({
  reducerPath: "analysis_primary_checking_account",
  baseQuery: createBaseQueryWithLogoutGuard({
    baseUrl: process.env.REACT_APP_API_URL,
  }),
  tagTypes: ["primary_checking_account"],
  endpoints: (build) => ({
    getPrimaryCheckingSummary: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/primary_checking_account/summary`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
    getPrimaryCheckingExpanded: build.query({
      query: ({ orgId, headers, payload }) => ({
        url: `/bank/${orgId}/dashboard/${payload.requid}/primary_checking_account/expand`,
        method: "POST",
        headers: headers,
        body: payload,
      }),
    }),
  }),
});

export const {
  useGetPrimaryCheckingSummaryQuery,
  useGetPrimaryCheckingExpandedQuery,
} = primaryCheckingAccountSlice;
